import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  oldbanks: [],
  oldbank: {},
  oldbankIds: [],
};

export const getOldBanks = createAsyncThunk(
  'oldBanks/getOldBanks',
  async () => {
    const { data } = await api.get('/old_accounts/oldbanks');

    return data;
  },
);

export const getOldBankIds = createAsyncThunk(
  'oldBanks/getOldBankIds',
  async query => {
    const { data } = await api.get('/old_accounts/oldbanks/ids', query);

    return data;
  },
);

export const getOldBank = createAsyncThunk('oldBanks/getOldBank', async id => {
  const { data } = await api.get(`/old_accounts/oldbanks/${id}`);

  return data;
});

export const deleteOldBank = createAsyncThunk(
  'oldBanks/deleteOldBank',
  async id => {
    await api.delete(`/old_accounts/oldbanks/${id}`);

    return id;
  },
);

export const restoreOldBank = createAsyncThunk(
  'oldBanks/restoreOldBank',
  async id => {
    await api.put(`/old_accounts/oldbanks/restore/${id}`);

    return id;
  },
);

export const addOldBank = createAsyncThunk(
  'oldBanks/addOldBank',
  async data => {
    const { data: bank } = await api.post('/old_accounts/oldbanks', data);

    return bank;
  },
);

export const editOldBank = createAsyncThunk(
  'oldBanks/editOldBank',
  async ({ id, data }) => {
    const { data: bank } = await api.put(`/old_accounts/oldbanks/${id}`, data);

    return bank;
  },
);

const oldBanks = createSlice({
  name: 'oldBanks',

  initialState,

  reducers: {
    clearOldBanks: draft => {
      draft.oldbanks = initialState.oldbanks;
    },

    clearOldBank: draft => {
      draft.oldbank = initialState.oldbank;
    },

    clearOldBankIds: draft => {
      draft.oldbankIds = initialState.oldbankIds;
    },
  },

  extraReducers: builder => {
    builder.addCase(getOldBanks.fulfilled, (draft, { payload }) => {
      draft.oldbanks = payload;
    });

    builder.addCase(getOldBank.fulfilled, (draft, { payload }) => {
      draft.oldbank = payload;
    });

    builder.addCase(deleteOldBank.fulfilled, (draft, { payload }) => {
      draft.oldbanks = draft.oldbanks.filter(el => el.id !== payload);
    });

    builder.addCase(restoreOldBank.fulfilled, (draft, { payload }) => {
      draft.oldbanks = draft.oldbanks.filter(el => el.id !== payload);
    });

    builder.addCase(addOldBank.fulfilled, (draft, { payload }) => {
      draft.oldbanks.push(payload);
    });

    builder.addCase(editOldBank.fulfilled, (draft, { payload }) => {
      const index = draft.oldbanks.findIndex(el => el.id === payload.id);

      draft.oldbanks[index] = payload;
    });

    builder.addCase(getOldBankIds.fulfilled, (draft, { payload }) => {
      draft.oldbankIds = payload;
    });

    builder.addMatcher(
      isAnyOf(
        getOldBanks.rejected,
        getOldBank.rejected,
        deleteOldBank.rejected,
        restoreOldBank.rejected,
        addOldBank.rejected,
        editOldBank.rejected,
        getOldBankIds.rejected,
      ),
      (_Draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearOldBanks, clearOldBank, clearOldBankIds } =
  oldBanks.actions;

export default oldBanks.reducer;
